import { CatalogEntity } from 'backend-entity';

export type CrmGetAvailableCatalogModificationsResponseDto = Pick<
  CatalogEntity,
  'modificationId' | 'modificationName' | 'modelId' | 'modelName' | 'brandId' | 'brandName'
> & {
  availableVehicleCount: number;
};
